import React from 'react';
import { Input } from '@spark';
import { HelpIcon } from '../shared/TaskTypeControls';

export const DISCOVERY_LINK_HINT = 'Press ↵ Enter to discover tools';

/**
 * "MCP Link *" / "Swagger Link *" input of a discovery-driven card (Figma
 * 3926-8787, Input Single Select w-440). Discovery runs on Enter and on blur
 * when the link changed since the last run.
 */
const DiscoveryLinkField = ({
    label,
    helpText,
    placeholder,
    value,
    onChange,
    onDiscover,
    error = null,
    disabled = false,
    className = '',
}) => (
    <div className={`cw-ac-link-field ${className}`.trim()}>
        <div className="cw-section-label">
            {label}
            <span className="cw-required-asterisk">*</span>
            <HelpIcon text={helpText} />
        </div>
        <Input
            size="medium"
            showLabel={false}
            showHelperText={false}
            placeholder={placeholder}
            aria-label={label}
            value={value}
            disabled={disabled}
            danger={Boolean(error)}
            onChange={(e) => onChange(e.target.value)}
            onBlur={() => onDiscover('blur')}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    onDiscover('enter');
                }
            }}
            className="cw-ac-link-field__input"
        />
        {error ? (
            <div className="cw-field-error">{error}</div>
        ) : (
            <div className="cw-ac-link-field__hint">{DISCOVERY_LINK_HINT}</div>
        )}
    </div>
);

export default DiscoveryLinkField;
